import React, { useEffect, useRef, useState } from 'react';
import { Animated, findNodeHandle, Keyboard, View } from 'react-native';
import SectionHeader from './SectionHeader';
import Collapsible from 'react-native-collapsible';
import { TouchableNative } from '../../design/components';
import { designConstants } from '../../design/styles';
import { calculateAnimationDuration } from '../utilities/animutils';
import { trackButtonPress } from '../utilities/gatracker';
import setTestID from '../utilities/setTestID';
import useThemeContext from '../../design/styles/useThemeContext';

export default function Section(props) {
  let headerHeight = new Animated.Value(70);
  const { colors } = useThemeContext();
  const [expanded, setExpanded] = useState(props.expanded || false);
  const [loading, setLoading] = useState(true);
  const sectionRef = useRef();
  const scrollPosition = new Animated.Value(0);
  const isTablet = designConstants.useIsTablet();
  const marginVertical = 5;

  scrollPosition.addListener(({ value }) => {
    props.scroll?.scrollContentTo &&
      props.scroll.scrollContentTo({
        x: 0,
        y: value,
        animated: false,
      });
  });

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    });
  }, []);

  const onSectionPress = () => {
    if (!props.children) {
      //Do not expand if there is no children
      return;
    }
    let expandedNew = !expanded;
    if (expandedNew) {
      trackButtonPress('Section Header ' + (props.tag || props.header));
    }
    setExpanded(expandedNew);

    // console.log('ONSECTIONPRESS', orios.s)
    props.scroll?.currentScroll &&
      scrollPosition.setValue(props.scroll.currentScroll);

    if (expandedNew) {
      //We need to scroll now!
      //Do not on web for now
      if (!designConstants.isWeb) {
        scroll();
      }
    }
  };

  const onContentLayout = (e) => {
    Animated.timing(this.state.measuredHeight, {
      toValue: e.nativeEvent.layout.height,
      duration: 300,
    }).start();
  };

  const onChildLayout = (e) => {
    if (expanded) {
      const y = e.nativeEvent.layout.y;
      props.scroll?.scrollContentTo &&
        props.scroll.scrollContentTo({
          x: 0,
          y,
          animated: true,
        });
    }
  };

  const scroll = () => {
    //we need to scroll with timeout, because before screen is actually animated we will be limited by scrollview
    if (sectionRef.current && props.scroll) {
      sectionRef.current.measureLayout(
        findNodeHandle(props.scroll),
        (x, y, width, height) => {
          let diff = y - scrollPosition.__getValue();
          const duration = calculateAnimationDuration(diff);
          Animated.timing(scrollPosition, {
            toValue: y,
            duration,
            useNativeDriver: false,
          }).start();
        },
      );
    }
  };

  const onPress = () => {
    Keyboard.dismiss();
    props.onCheckPressed ? props.onCheckPressed() : onSectionPress();
  };

  const { counter, childrenProps } = props;

  const SectionCounter = counter;
  const sectionProps =
    childrenProps || (props.children && { ...props.children.props });
  return (
    <Animated.View
      ref={sectionRef}
      style={{
        backgroundColor: colors.defaultBackground,
        borderRadius: isTablet ? 8 : 0,
        borderColor: colors.cardBorder,
        paddingHorizontal: isTablet ? 0 : 10,
        elevation: 0,
        paddingTop: props.first ? 10 : marginVertical,
        paddingBottom: props.last ? 10 : marginVertical,
      }}
    >
      <View
        style={{
          backgroundColor: colors.defaultBackground,
          borderWidth: 1,
          borderRadius: 4,
          borderColor: colors.cardBorder,
          marginHorizontal: isTablet ? 10 : 0,
          elevation: 0,
        }}
      >
        <View
          style={{
            padding: 1,
          }}
        >
          <TouchableNative
            onPress={props.onPress || onPress}
            pointerEvents={'auto'}
            {...setTestID(props.tag)}
          >
            <View>
              <SectionHeader
                style={{
                  alignSelf: 'stretch',
                  minHeight: headerHeight,
                }}
                {...props}
                renderCounter={
                  SectionCounter && <SectionCounter {...sectionProps} />
                }
                onExpandPressed={onSectionPress}
                expanded={expanded}
                canExpand={!!props.children}
              />
            </View>
          </TouchableNative>

          {!loading && props.children && (
            <Collapsible collapsed={!expanded} onLayout={onChildLayout}>
              {React.cloneElement(props.children, {
                expanded: expanded,
              })}
            </Collapsible>
          )}
        </View>
      </View>
    </Animated.View>
  );
}
